import React from 'react';
import { Typography } from '@mui/material';
import { ModalType } from 'entities/modal/model';
import { ECOSYSTEM_LINKS, Icons, ModalSidebar } from 'shared';

export interface BridgeModalPayload {
  data?: null;
  type: ModalType.Bridge;
  isOpen?: boolean;
}

export const BridgeModal = React.forwardRef<
  HTMLElement,
  Pick<BridgeModalPayload, 'data' | 'isOpen'> & { onClose: VoidFunction }
>(({ onClose, isOpen }, ref) => {
  return (
    <ModalSidebar
      isOpen={isOpen}
      ref={ref}
      onClose={onClose}
      title="Multi-Chain Bridge"
      subtitle="Connecting CratD2C to Other Blockchains"
      icon={<Icons.BridgeDark />}
      link={{
        title: 'Bridge Now',
        link: {
          href: ECOSYSTEM_LINKS.bridge,
          text: ECOSYSTEM_LINKS.bridge,
        },
      }}
    >
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        The Multi-Chain Bridge makes CratD2C interoperable with other EVM-compatible networks.
      </Typography>
      <br />
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        Users can move assets between CratD2C and other chains, opening access to more liquidity, DeFi options, and
        users.
      </Typography>
      <br />
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        For non-technical people: it’s like a secure tunnel that lets your crypto travel between different blockchain
        “countries.”
      </Typography>
    </ModalSidebar>
  );
});
